import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getComboUbicacionPadre`, method: 'GET', body: null, token: token})
}